import unescapeHTML from 'unescape';

import type { ParsedFormattedString, ParsedFormattedStringPart } from './types';

/**
 * Parses the given HTML string into an array of objects with text and formatting. The returned
 * array can be looped over to generate a string with highlighted text.
 */
export function parseFormatString(string: string): ParsedFormattedString {
    const splitRegex = /(<b>|<\/b>)/gm;

    const parsedParts: ParsedFormattedString = [];
    let currentPart: ParsedFormattedStringPart = {
        text: '',
    };
    const parts = string.split(splitRegex);

    // Loop through all the parts of the HTML string, which will include teh text and HTML tags.
    parts.forEach((part) => {
        part = part.trim();

        // If the part is an opening tag and we have some text already, commit that text and
        // open a new part. Same thing for closing tags.
        if ((part === '<b>' || part === '</b>') && currentPart.text !== '') {
            parsedParts.push(currentPart);
            currentPart = {
                text: '',
            };
        }

        // Process opening tags and text
        if (part === '<b>') {
            currentPart.bold = true;
        } else if (part !== '' && part !== '</b>') {
            currentPart.text = unescapeHTML(part);
        }
    });

    // If we didn't insert the last text element, do it now.
    if (currentPart.text !== '') {
        parsedParts.push(currentPart);
    }

    return parsedParts;
}
